import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import LogoText from '../../assets/images/logo.png'
import Alert from '../../components/UI/Alert/Alert'
import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input'
import { properties } from '../../shared/properties'
import { checkValidity, updateObject } from '../../shared/utility'
import './Login.css'

class Login extends Component {

    state = {
        controls: {
            username: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'نام کاربری'
                },
                validation: {
                    required: true
                },
                errorMessage: '',
                valid: true,
                value: ''
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'رمز عبور'
                },
                validation: {
                    required: true
                },
                errorMessage: '',
                valid: true,
                value: ''
            }
        },
        showError: false,
        errorContent: '',
        hasLogin: false
    };

    inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(this.state.controls, {
            [controlName]: updateObject(this.state.controls[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, this.state.controls[controlName].validation),
                errorMessage: this.state.controls[controlName].elementConfig.placeholder + ' صحیح نیست'
            })
        });
        this.setState({ controls: updatedControls });
    }

    login = (event) => {
        this.setState({ showError: false })
        event.preventDefault();
        let controls = { ...this.state.controls };
        let hasError = false
        for (let key in this.state.controls) {
            let element = { ...controls[key] }
            if (element.value == '') {
                hasError = true
                element.valid = false
                element.errorMessage = element.elementConfig.placeholder + ' الزامی است'
                controls[key] = element
                this.setState({ controls })
            }
        }
        if (!hasError) {
            var raw = JSON.stringify({ "username": this.state.controls.username.value, "password": this.state.controls.password.value })
            var url = 'token'
            var myHeaders = new Headers();
            //            let baseUrl = 'http://86.104.33.119:8081/'
            let baseUrl = properties.baseUrl
            myHeaders.append("Content-Type", "application/json");
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };
            fetch(baseUrl + url, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.token != '' && result.token != null) {

                        window.localStorage.setItem("expiration", result.expirationDate)
                        window.localStorage.setItem("token", result.token)
                        window.localStorage.setItem("username", this.state.controls.username.value)
                        window.localStorage.setItem("password", this.state.controls.password.value)
                        var oneYearFromNow = new Date();
                        oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
                        window.localStorage.setItem("accepted", oneYearFromNow);
                        myHeaders.append("Authorization", result.token)
                        var info = {
                            "version": "mtpx001"
                        }
                        var raw = JSON.stringify(info)
                        var url = 'management/api/v1/users/getMyInfo'
                        requestOptions = {
                            method: 'POST',
                            headers: myHeaders,
                            body: raw,
                            redirect: 'follow'
                        };
                        fetch(baseUrl + url, requestOptions)
                            .then(response => response.json())
                            .then(result => {
                                window.localStorage.setItem("permission", result.user.permission)
                                window.localStorage.setItem("userId", result.user.id)
                                this.setState({ hasLogin: true })
                            })
                            .catch(error => console.log(error))


                    } else if (result.status != 0) {
                        this.setState({ showError: true, errorContent: 'نام کاربری یا رمز عبور صحیح نیست!' })
                    }
                })
                .catch(error => this.setState({ showError: true, errorContent: 'نام کاربری یا رمز عبور صحیح نیست!' }))
        }
    }
    hideAlert = (event) => {
        this.setState({ showError: false })
    }

    render() {
        if (this.props.token !== '' && this.props.token !== null) {
        }
        const formElementsArray = [];
        for (let key in this.state.controls) {
            formElementsArray.push({
                id: key,
                config: this.state.controls[key]
            });
        }
        let form = formElementsArray.map(formElement => {
            return (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    placeholder={formElement.config.placeholder}
                    errorMessage={formElement.config.errorMessage}
                    col="12 mt-3"
                    changed={(event) => this.inputChangedHandler(event, formElement.id)} />
            );
        })

        let LoginClass = "fadeIn"
        const path = '/'
        const isLogin = this.state.hasLogin == true ? <Redirect to={path} /> : ''
        return (
            <div className="Cntnr">
                {isLogin}
                <div className={LoginClass}>
                    <div className="row justify-content-center pb-5">
                        <div className="LoginForm mt-5">
                            <form>
                                <div className="row justify-content-center">
                                    <img class="login-logo" src={LogoText} />
                                </div>
                                <div className="row justify-content-center mt-4">
                                    {form}
                                </div>
                                <div className="row justify-content-center mt-5">
                                    <div className="col-md-12">
                                        <Button className="LoginBtn" clicked={this.login} >ورود</Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {this.state.showError == true ?
                            <div className="row justify-content-center mt-5 alert-cntnr-login">
                                <Alert afterShow={this.hideAlert} variant="error" class="mt-3" isLogin={true} text={this.state.errorContent} />
                            </div>
                            : ''}
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(Login)